import { useCallback } from 'react'

import { errorView, normalizeResourceId } from '@krp/client-runtime'
import { DUPLICATES_SECTION, duplicateSources, summaryLine } from '@krp/duplicates-ui'

/**
 * Строки под названием источника на плитке выбора источника раздела (RP-DUP8, И-2). Раздел, которому есть что сказать об
 * источнике, подключается здесь; платформенные привязки о разделах не знают. Хук один и вызывается безусловно: данные
 * раздела запрашиваются только для него (`skip`), у остальных разделов строк нет.
 */
export type TileNotes = (resourceId: string) => readonly string[]

const NO_NOTES: readonly string[] = []

/**
 * Итог последней проверки на плитке раздела «Дубли»: «23.10 14:05 · 128 пар · 40 отмечено». Сведения не пришли — так и сказано
 * дословным текстом службы, а не молчаливо пустая плитка.
 */
export function useSectionTileNotes(sectionId: string): TileNotes {
  const { data, error } = duplicateSources.useQuery(undefined, { skip: sectionId !== DUPLICATES_SECTION })
  return useCallback(
    (resourceId) => {
      if (sectionId !== DUPLICATES_SECTION) return NO_NOTES
      if (error !== undefined) return [`Последняя проверка неизвестна: ${errorView(error).message}`]
      if (data === undefined) return NO_NOTES
      const source = data.find((item) => normalizeResourceId(item.id) === normalizeResourceId(resourceId))
      if (source === undefined) return NO_NOTES
      return [source.lastScan === null ? 'Проверка ещё не запускалась' : `Последняя проверка: ${summaryLine(source.lastScan)}`]
    },
    [sectionId, data, error],
  )
}
